export class NavItem {

  public displayText: string;
  public path: string;
  public newTab: boolean;

  constructor(theDisplayText: string, thePath: string, needsNewTab: boolean = false){
    this.displayText = theDisplayText;
    this.path = thePath;
    this.newTab = needsNewTab;
  }
}
